import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { Auth0WrapperService } from '@auth/bp-pf-auth';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-producer-flow-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './producer-flow-modal.component.html',
  styleUrl: './producer-flow-modal.component.scss'
})
export class ProducerFlowModalComponent {
  @Input() displayMode: 'popup' | 'layout' = 'popup';
  @Input() onboardingUrl = '';
  @Input() agentId = '';
  @Input() agentName = '';
  @Input() agencyName = '';
  @Input() npn = '';
  @Input() licenseStatus = '';
  @Input() email = '';
  @Input() supportEmail = 'help@greenshieldrisk.com';
  @Input() supportHours = '';
  @Input() turnaroundText = '';
  public isCopied = false;
  private copiedStateTimer: ReturnType<typeof setTimeout> | null = null;

  private readonly activeModal = inject(NgbActiveModal, { optional: true });

  constructor(private auth: Auth0WrapperService) { }

  get isPopupMode(): boolean {
    return this.displayMode === 'popup';
  }

  get shortOnboardingUrl(): string {
    return this.onboardingUrl;
  }

  continueToProducerFlow(): void {
    if (!this.onboardingUrl) {
      return;
    }

    window.open(this.onboardingUrl, '_blank', 'noopener,noreferrer');
  }

  async copyOnboardingLink(): Promise<void> {
    if (!this.onboardingUrl || !navigator.clipboard) {
      return;
    }

    await navigator.clipboard.writeText(this.onboardingUrl);
    this.isCopied = true;

    if (this.copiedStateTimer) {
      clearTimeout(this.copiedStateTimer);
    }

    this.copiedStateTimer = setTimeout(() => {
      this.isCopied = false;
      this.copiedStateTimer = null;
    }, 1200);
  }

  closeModal(): void {
    this.activeModal?.close();
  }

  redirectToHomePage(): void {
    this.auth.logoutWithRedirect();
  }
}
